(function () {
    'use strict';

    angular.module("imApp").factory("operationMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 2035,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
